import React, { useState, ReactNode, createContext } from 'react'

interface AppContextType {
  activeKeys: string[]
  setActiveKeys: React.Dispatch<React.SetStateAction<string[]>>
}

export const AppContext = createContext<AppContextType | undefined>(undefined)

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [activeKeys, setActiveKeys] = useState<string[]>([])
  const value = { activeKeys, setActiveKeys }

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  )
}
